import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import {
  GetMarathonsDistancesParams,
  GetMarathonsDistancesResponse,
} from "api/api/marathonsApi/types";
import axios from "axios";

export const getMarathonsDistances = createAsyncThunk<
  GetMarathonsDistancesResponse,
  GetMarathonsDistancesParams
>(
  "marathons/getMarathonsDistances",
  async ({ marathonId, ...params }, { rejectWithValue }) => {
    try {
      const data = await MarathonsAPI.getMarathonsDistances({
        marathonId,
        ...params,
      });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting marathons distances",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting marathons distances", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
